/* eslint-disable no-useless-escape */
/* eslint-disable no-else-return */
/* eslint-disable prefer-template */
/*
 * Created Date: 20-08-2022, 12:50:29 am
 * Author: TheAnh58
 * Email: you@you.you
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2022 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { format, isValid } from 'date-fns'
import moment from 'moment'

export const generateGUID = () => {
	function S4() {
		return Math.floor((1 + Math.random()) * 0x10000)
			.toString(16)
			.substring(1)
	}
	return S4() + S4()
}
export const isEmail = email => {
	return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)
}
export const isPhoneNumber = str => {
	return /(\+84|\84|0)+(3[2-9]|5[6|8|9]|9\d(?!5)|8[1-9]|7[0|6-9])+([0-9]{7})\b/i.test(str)
}
export const changeToAlias = string => {
	return string
		.trim()
		.normalize('NFD')
		.toLowerCase()
		.replace(/\s\s+/g, ' ')
		.replace(/[\u0300-\u036f]/g, '')
		.replace(/đ/g, 'd')
		.replace(/`|~|!|@|"|#|\||\$|%|\^|&|\*|\(|\)|\+|=|,|\.|\/|\?|>|<|'|"|:|;|/gi, '')
		.replace(/ /g, '-')
		.replace(/_/g, '-')

		.replace(/-----/gi, '-')
		.replace(/----/gi, '-')
		.replace(/---/gi, '-')
		.replace(/--/gi, '-')
		.replace(/"-|-"|"/gi, '')
}
// eslint-disable-next-line default-param-last
export const formatDate = (string, withFormat = 'DD/MM/YYYY', locale) => {
	return string && isValid(new Date(string)) ? moment(string).format(withFormat) : null
}

export const formatDateVn = (string, options) => {
	return new Date(string).toLocaleDateString('vi-VN', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
		...options
	})
}

export const formatPrice = (priceString, delimiter = ',', currency = 'đ') => {
	if (!priceString) {
		return 0
	}

	return priceString.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${delimiter}`) + currency
}

export const stringToColor = string => {
	let hash = 0
	let i

	/* eslint-disable no-bitwise */
	for (i = 0; i < string?.length; i += 1) {
		hash = string.charCodeAt(i) + ((hash << 5) - hash)
	}

	let color = '#'

	for (i = 0; i < 3; i += 1) {
		const value = (hash >> (i * 8)) & 0xff
		color += `00${value.toString(16)}`.slice(-2)
	}
	/* eslint-enable no-bitwise */

	return color
}
export const formatStatisNumber = num => {
	const number = Number(num ?? 0)
	if (number >= 1000000) {
		const millionCount = Math.floor(number / 1000000)
		const remainder = Math.floor((number % 1000000) / 100000) // One decimal place

		if (remainder === 0) {
			// eslint-disable-next-line prefer-template
			return millionCount + 'm+'
			// eslint-disable-next-line no-else-return
		} else {
			return millionCount + '.' + remainder + 'm+'
		}
	} else {
		return number.toLocaleString()
	}
}

export const toHHMMSS = second => {
	const sec_num = parseInt(second, 10) // don't forget the second param
	let hours = Math.floor(sec_num / 3600)
	let minutes = Math.floor((sec_num - hours * 3600) / 60)
	let seconds = sec_num - hours * 3600 - minutes * 60

	if (hours < 10) {
		hours = '0' + hours
	}
	if (minutes < 10) {
		minutes = '0' + minutes
	}
	if (seconds < 10) {
		seconds = '0' + seconds
	}
	return hours + ':' + minutes + ':' + seconds
}

export const removeTextTones = str => {
	str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a')
	str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e')
	str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i')
	str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o')
	str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u')
	str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y')
	str = str.replace(/đ/g, 'd')
	str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A')
	str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E')
	str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I')
	str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O')
	str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U')
	str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y')
	str = str.replace(/Đ/g, 'D')
	// Some system encode vietnamese combining accent as individual utf-8 characters
	// Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
	str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, '') // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
	str = str.replace(/\u02C6|\u0306|\u031B/g, '') // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
	// Remove extra spaces
	// Bỏ các khoảng trắng liền nhau
	str = str.replace(/ + /g, ' ')
	str = str.trim()
	// Remove punctuations
	// Bỏ dấu câu, kí tự đặc biệt
	str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, ' ')
	return str
}
